import {Component, Input, OnInit, input, ChangeDetectionStrategy} from '@angular/core';
import type NavigationMenu from "../navigation.model";

@Component({
    selector: 'app-navigator',
    templateUrl: './navigator.component.html',
    styleUrls: ['./navigator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigatorComponent {

  navigationMenu = input<NavigationMenu []>();

}